import { useEffect, useState, useMemo } from 'react';

import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';

export default function TextFieldComponent(props) {
  const {
    maxLength,
    defaultValue,
    name,
    control,
    fullWidth = true,
    minRows,
    isError,
    placeholder,
    label
  } = props;

  const [count, setCount] = useState(0);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (defaultValue) {
      setInputValue(defaultValue);
      setCount(defaultValue.length);
    }
  }, [defaultValue]);

  const handleChange = (e, trim) => {
    let val = trim ? e.target.value.trim() : e.target.value;

    if (val.length > maxLength) return;

    setInputValue(val);
    setCount(val.length);
  };

  const helperText = useMemo(() => {
    let text = `${count}/${maxLength}`;

    if (count === maxLength) {
      text += ' - Max Reached';
    }

    return text;
  }, [inputValue]);

  return (
    <Controller
      render={({ field }) => (
        <TextField
          multiline
          minRows={minRows ? minRows : 1}
          value={field.value}
          helperText={helperText}
          onChange={field.onChange}
          onBlur={field.onBlur}
          onFocus={(e) => handleChange(e, true)}
          onKeyDown={(e) => handleChange(e, true)}
          onKeyUp={(e) => handleChange(e, true)}
          error={isError}
          fullWidth={fullWidth}
          inputProps={{ maxLength: maxLength }}
          placeholder={placeholder}
          label={label}
        />
      )}
      defaultValue={defaultValue}
      name={name}
      control={control}
    />
  );
}
